import qs from 'qs'
import i18n from '@signavio/i18n'

import { LegacyHint, PlaceholderTile, TextTile } from '@signavio/ui'

import { useApi } from '../../api'
import apiTypes from '../../apiTypes'
import { getRootUrl } from '../../callApi'

import FileBase from './FileBase'

import { File } from '../../../types'

type ParamsType = {
  workflowId: string
}

type FileProps = {
  showImage?: boolean
  small?: boolean
  params: ParamsType
  transparent?: boolean
  fileId: string
}

function FileComponent({
  fileId,
  params,
  showImage,
  small,
  transparent,
}: FileProps) {
  const [fetchFile] = useApi(apiTypes.PUBLIC_FILE, {
    query: {
      ...params,
      id: fileId,
    },
  })

  if (fetchFile.pending) {
    return (
      <PlaceholderTile withHeader small={small} transparent={transparent} />
    )
  }

  if (fetchFile.rejected) {
    return (
      <TextTile {...{ small, transparent }}>
        <LegacyHint inline danger small={small}>
          {i18n('Could not load file.')}
        </LegacyHint>
      </TextTile>
    )
  }

  if (!fetchFile.value) {
    return null
  }

  const file = fetchFile.value
  const src = getSrc(file, params)

  return (
    <FileBase
      src={src}
      file={file}
      showImage={showImage}
      small={small}
      transparent={transparent}
    />
  )
}

const getSrc = (file: File, params: ParamsType) => {
  const src = `${getRootUrl()}/public/files/${file.id}/stream`

  return `${src}${qs.stringify(
    params,

    {
      addQueryPrefix: true,
    }
  )}`
}

export default FileComponent
